import { render, staticRenderFns } from "./Clienti_dialog.vue?vue&type=template&id=9038e79e&scoped=true&"
import script from "./Clienti_dialog.vue?vue&type=script&lang=js&"
export * from "./Clienti_dialog.vue?vue&type=script&lang=js&"
import style0 from "./Clienti_dialog.vue?vue&type=style&index=0&id=9038e79e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9038e79e",
  null
  
)

export default component.exports